export default __webpack_public_path__ + "img/pattern_vue.723fd347.png";